import bigDecimal from 'js-big-decimal'

/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-plusplus */
const sinal = x => {
  return x < 0.0 ? -1 : 1
}

const onGetVPL = (taxa, montantes) => {
  let ret = montantes[0]

  for (let i = 1; i < montantes.length; i++)
    ret += montantes[i] / Math.pow(1.0 + Math.abs(taxa), i)

  return ret
}

const onConvertNumber = value =>
  value
    .toString()
    .replace(/[.\s]/g, '')
    .replace(/[,\s]/g, '.')

const onGetTIR = montantes => {
  let juros_inicial = -1.0
  let juros_medio = 0.0
  let juros_final = 1.0
  let vpl_inicial = 0.0
  let vpl_final = 0.0
  let erro = 1e-5

  for (let i = 0; i < 100; i++) {
    vpl_inicial = onGetVPL(juros_inicial, montantes)
    vpl_final = onGetVPL(juros_final, montantes)
    if (sinal(vpl_inicial) !== sinal(vpl_final)) break
    juros_inicial -= 1.0
    juros_final += 1.0
  }
  let count = 0
  for (;;) {
    // Busca por Bisseção
    juros_medio = (juros_inicial + juros_final) / 2.0
    const vpl_medio = onGetVPL(juros_medio, montantes)

    if (Math.abs(vpl_medio) <= erro) {
      // Resultado foi encontrado
      return juros_medio * 100.0
    }
    if (sinal(vpl_inicial) === sinal(vpl_medio)) {
      juros_inicial = juros_medio
      vpl_inicial = onGetVPL(juros_medio, montantes)
    } else {
      juros_final = juros_medio
      vpl_final = onGetVPL(juros_medio, montantes)
    }
    if (++count > 10000) return 0
  }
}

const onFormatNegate = value => {
  const result = bigDecimal.negate(onConvertNumber(value))

  return bigDecimal
    .getPrettyValue(result)
    .replace(/[.\s]/g, '*')
    .replace(/[,\s]/g, '.')
    .replace(/[*\s]/g, ',')
}

const onFormatTIRValue = (value, decimal = 2) => {
  if (value === '#NUM!') return '0,00'

  if (
    value === Number.POSITIVE_INFINITY ||
    value === Number.NEGATIVE_INFINITY
  ) {
    return '0,00'
  }

  let result = parseFloat(value) * 100

  result = (parseFloat(result) / 100).toFixed(decimal)

  return bigDecimal
    .getPrettyValue(result)
    .replace(/[.\s]/g, '*')
    .replace(/[,\s]/g, '.')
    .replace(/[*\s]/g, ',')
}

const onFormatInputValue = (value, decimal = 2) => {
  if (value === '0') return value

  const result = bigDecimal.round(
    onConvertNumber(value),
    decimal,
    bigDecimal.RoundingModes.HALF_EVEN,
  )

  return bigDecimal
    .getPrettyValue(result)
    .replace(/[.\s]/g, '*')
    .replace(/[,\s]/g, '.')
    .replace(/[*\s]/g, ',')
}

const onFormatResultValue = (value, decimal = 2) => {
  const result = bigDecimal.round(
    parseFloat(value),
    decimal,
    bigDecimal.RoundingModes.HALF_EVEN,
  )

  if (
    result === 'Infinity.00' ||
    result === '-Infinity.00' ||
    result === 'Infinity.00000'
  ) {
    return value
  }

  return bigDecimal
    .getPrettyValue(result)
    .replace(/[.\s]/g, '*')
    .replace(/[,\s]/g, '.')
    .replace(/[*\s]/g, ',')
}

export {
  onConvertNumber,
  onGetTIR,
  onGetVPL,
  onFormatTIRValue,
  onFormatInputValue,
  onFormatResultValue,
  onFormatNegate,
}
